<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                md="3"
                xl="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in holiday name here"
                  append-icon="search"
                  label="Search holiday"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>

              <v-col
                cols="12"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="yearFilter"
                  clearable
                  :items="holidayYears"
                  label="Year Filter"
                  placeholder="Filter by year"
                />
              </v-col>

              <v-col
                cols="12"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="stateFilter"
                  clearable
                  :items="states"
                  item-text="name"
                  item-value="id"
                  label="State Filter"
                  placeholder="Filter by state"
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
                xl="2"
              >
                <!-- <setup-holidays-details-dialog-copy 
                  :states="states"
                  :available-years="holidayYears"
                  @created="handleDetailCopied"
                /> -->
              </v-col>

              <v-col
                cols="12"
                md="2"
                xl="2"
              >
                <!-- <setup-holidays-details-dialog-create 
                  :states="states"
                  @created="refreshData"
                /> -->
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :single-expand="false"
            show-expand
            :items="filteredHolidays"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.holiday.name="{ item }">
              <div>
                <span class="font-weight-bold">
                  {{ item.holiday.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.stateNames="{ item }">
              <div>
                <span class="px-3 pl-0 font-weight-bold">
                  {{ item.stateNames }}
                </span>
              </div>
            </template>

            <template v-slot:item.date="{ item }">
              <div>
                <span class="px-3 pl-0">
                  {{ item.date }}
                </span>
              </div>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td />
           
              <v-treeview
                :items="item.states_departments"
                dense
              />
            </template>

            <!-- <template v-slot:item.action="{ item }">
              <setup-holidays-details-dialog-assign
                :states="states"
                :holiday-detail="item"
                @updated="refreshData"
              />
              <setup-holidays-details-dialog-delete
                :holiday-detail="item"
                @deleted="refreshData"
              />
              <span class="mx-1" />
            </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      // SetupHolidaysDetailsDialogCopy: () => import('@/components/setup/holidays/details/DialogCopy'),
      // SetupHolidaysDetailsDialogCreate: () => import('@/components/setup/holidays/details/DialogCreate'),
      // SetupHolidaysDetailsDialogAssign: () => import('@/components/setup/holidays/details/DialogAssign'),
      // SetupHolidaysDetailsDialogDelete: () => import('@/components/setup/holidays/details/DialogDelete'),
    },
    metaInfo () {
      return {
        title: 'Holidays Details',        
      }
    },
    data () {
      return {
        yearFilter: (new Date()).getFullYear(),
        stateFilter: null,
        holidayTypes: [
          { value: 'all', text: 'All' },
          { value: 'regional', text: 'Regional' },
          { value: 'national', text: 'National' },
        ],
        search: '',
        holidayDetails: [],
        headers: [
          {
            text: 'Holiday Name',
            align: 'left',
            value: 'holiday.name',
          },
          {
            text: 'States',
            value: 'stateNames',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Date',
            value: 'date',
            align: 'center',
          },
          {
            text: '',
            value: 'action',
            align: 'left',
          },
        ],
        states: [],
        
      }
    },
    computed: {
      holidayYears () {
        let years = this.holidayDetails.map((detail) => {
          return this.$moment(detail.date, 'YYYY-MM-DD').year()   
        })

        return [...new Set(years)]
      },
      filteredHolidays () {
        return this.holidayDetails
          .filter((detail) => {
            if (!this.yearFilter) return true

            return this.$moment(detail.date, 'YYYY-MM-DD').year() === this.yearFilter
          })
          .filter((detail) => {
            if (!this.stateFilter) return true

            let found = detail.holiday_states.find(state => {
              return state.state.id === this.stateFilter
            })

            return !!found
          })
      },
    },
    created () {
      this.refreshData()
    },  
    methods: {
      handleDetailCopied (year) {
        this.setYearFilter(year)
        this.refreshData()
      },
      setYearFilter (year) {
        this.yearFilter = year
      },
      loadHolidayDetails () {        
        this.tableLoading = true

        this.$api.holidayDetails().list('?filter[min_year]=' + (new Date().getFullYear() - 2))
          .then((response) => {
            response.data.forEach((detail) => {
              detail.states_departments = this.groupDeparmentsByState(detail.holiday_states)
              detail.states_departments.forEach(stateDepartment => {
                stateDepartment.children = this.changeToTreeStructure(stateDepartment.departments)
              })
    
              detail.stateNames = this.getStateCodes(detail.holiday_states)
              if (detail.stateNames.split(',').length === 16) {
                detail.stateNames = 'All'
              } else if (detail.stateNames.split(',').length === 0) {
                detail.stateNames = 'None'
              }
              detail.departmentIds = this.getDepartmentIds(detail.holiday_states)
            })       
         
            this.holidayDetails = _.orderBy(response.data, ['date'], ['asc'])
            this.tableLoading = false
          })
      },      
      refreshData () {
        this.loadHolidayDetails()
        this.loadStates()
      },
      loadStates () {
        this.$api.states().list()
          .then((res) => {
            this.states = res.data
          })
      },
      getStateCodes (states) {
        let codes = ''
        states.forEach((val, idx, src) => {          
          if (!codes.includes(val.state.code)) {  
            codes += val.state.code + ', '
          }
        })
        return codes.substring(0, codes.length - 2)
      },      

      groupDeparmentsByState (states) {
        let stateDepartments = _.chain(states)
          .groupBy('state.name')
          .map((value, key) => 
            ({ name: key, departments: value })
          )
          .value()
      
        return stateDepartments
      },

      changeToTreeStructure (data) {
        let departments = []

        data.forEach(val => {
          if (val.department) {
            departments.push({ name: val.department.name })
          }
        })
        return departments
      },

      getDepartmentIds (states) {
        let ids = []

        states.forEach(val => {
          if (val.department) {
            if (!ids.includes(val.department.id)) {
              ids.push(val.department.id)
            }
          }
        })
        return ids
      },      
    },
  }
</script>

<style lang='css' scoped>
</style>
